import React from "react";
import { ReactSVG } from "react-svg";

const PageTitle = (data) => {
  const { header, icon } = data;

  return (

    <div className="relative top-0 left-0 flex h-[140px] flex-col align-middle w-screen justify-center items-center mt-[0] 2xl:mt-11 scale-[0.7] 2xl:scale-[1]">
      <img src={icon} alt="Page icon" />
      <h1 className="pt-[11px] font-proxima-nova font-extralight text-dell-blue font-light text-page-title leading-[54px]">
        {header}
      </h1>
    </div>
  );
};

export default PageTitle;
